export enum UserRoles {
  Admin = 'admin',
  Collaborator = 'collaborator',
  Guest = 'guest',
  Owner = 'owner',
}
